// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-dialog .address-item[data-v-6eb523c5]{display:flex;font-size:14px;margin-bottom:30px;justify-content:center}.order-dialog .address-item .title[data-v-6eb523c5]{width:100px;text-align:right;margin-right:45px}.order-dialog .address-item .title span[data-v-6eb523c5]{color:#df5813}.order-dialog .address-item .content[data-v-6eb523c5]{width:230px;text-align:left}", ""]);
// Exports
module.exports = exports;
